import { render, staticRenderFns } from "./AgePanel.vue?vue&type=template&id=d894616c&scoped=true&"
import script from "./AgePanel.vue?vue&type=script&lang=ts&"
export * from "./AgePanel.vue?vue&type=script&lang=ts&"
import style0 from "./AgePanel.vue?vue&type=style&index=0&id=d894616c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d894616c",
  null
  
)

export default component.exports